<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>construction</mat-icon> {{isEdit ? 'Arbeiter bearbeiten' : 'Arbeiter anlegen'}}
</h2>

<mat-dialog-content class="dialog-content">
  <p class="sk-muted intro">
    Arbeiter haben <strong>keinen App-Zugang</strong>. Sie werden bei der Einsatzplanung
    zugeteilt – nur zur Information, wer wo eingesetzt war.
  </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="name" required placeholder="Vor- und Nachname"
           (keyup.enter)="save()" cdkFocusInitial>
    <mat-icon matPrefix>person</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Telefon (optional)</mat-label>
    <input matInput [(ngModel)]="phone" (keyup.enter)="save()">
    <mat-icon matPrefix>phone</mat-icon>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !name.trim()">
    <mat-icon>save</mat-icon> {{isEdit ? 'Speichern' : 'Anlegen'}}
  </button>
</mat-dialog-actions>
